import { Component } from '@angular/core';
import {
  CLIMATE_CARD_PANEL_IMPORTS,
  ClimateCardPanelComponent,
} from 'src/app/panels/components/card/climate-card-panel/climate-card-panel.component';
import { PanelComponent } from 'src/app/panels/components/panel.component';
import { PanelType } from 'src/app/panels/models/panel-type';

@PanelComponent.register
@Component({
  templateUrl: './../../../../panels/components/card/climate-card-panel/climate-card-panel.component.html',
  styleUrl: './../../../../panels/components/card/climate-card-panel/climate-card-panel.component.scss',
  selector: 'app-weather-station-outside-climate-card-panel',
  imports: CLIMATE_CARD_PANEL_IMPORTS,
})
export class WeatherStationOutsideClimateCardPanelComponent extends ClimateCardPanelComponent {
  public static override readonly type = PanelType.WeatherStationOutsideClimateCard;
}
